import { ChainId } from '@agent13/sdk-rei'
import MULTICALL_ABI from './abi.json'

const MULTICALL_NETWORKS: { [chainId in ChainId]: string } = {
	[ChainId.MAINNET]: '0x6e2A64fE96732C8D4cA9DfF8DAf3178C25D2b434', // TODO
	[ChainId.BSCTESTNET]: '0x301907b5835a2d723Fe3e9E8C5Bc5375d5c1236A',
}

export { MULTICALL_ABI, MULTICALL_NETWORKS }
